G.ActionProcessFall = function(board,am,args) {

	G.Action.call(this,board,am,args);

	this.madeCrossCollumn = false;

	this.board.fallMgr.allCollumsFall();
   
};

G.ActionProcessFall.prototype = Object.create(G.Action.prototype);

G.ActionProcessFall.prototype.update = function() {

	if (!this.board.duringAnimation && !this.board.duringFall) {

		
			if (!this.madeCrossCollumn) {
				while(true) {
					if (!this.board.fallMgr.crossCollumnFall()) break;
				}
				this.madeCrossCollumn = true;
				return;
			}

			//check if candies that have fallen are making match
			this.board.fallCheckList.forEach(function(candy) {
				if (this.board.matcher.quickMatchCheck(candy)) {
					this.board.checkMatchList.push(candy);
				}
			},this);
			this.board.fallCheckList = [];


			if (this.board.checkMatchList != false || this.board.checkAfterFall.length > 0) {

				//check after fall to checkmatchlist
				for (var i = 0, len = this.board.checkAfterFall.length; i < len; i++) {
					this.board.checkMatchList.push(this.board.checkAfterFall[i]);
				}
				this.board.checkAfterFall = [];

				this.am.newAction('processMatch');
			}

			G.sb("actionFallEnd").dispatch();

      //new action added
      this.board.checkGoalCandy();

			this.finish();

	}

};